import { ProjectStatusDto } from "@domain/project/template/property/project/details/information/project-status.dto";
import { Type } from "class-transformer";
import { IsArray, IsOptional, ValidateNested } from "class-validator";
import { TemplateInformationFieldDto } from "./template-information-field.dto";

export class TemplateInformationDto {
  @IsArray()
  @Type(() => ProjectStatusDto)
  @ValidateNested({ each: true })
  statuses!: ProjectStatusDto[];

  @IsOptional()
  @Type(() => TemplateInformationFieldDto)
  forzaId?: TemplateInformationFieldDto;

  @IsOptional()
  @Type(() => TemplateInformationFieldDto)
  placeName?: TemplateInformationFieldDto;

  @IsOptional()
  @Type(() => TemplateInformationFieldDto)
  region?: TemplateInformationFieldDto;

  @IsOptional()
  @Type(() => TemplateInformationFieldDto)
  draegerContactPerson?: TemplateInformationFieldDto;

  @IsOptional()
  @Type(() => TemplateInformationFieldDto)
  opportunityId?: TemplateInformationFieldDto;

  @IsOptional()
  @Type(() => TemplateInformationFieldDto)
  opportunityLink?: TemplateInformationFieldDto;
}
